<template>
  <form class="flex flex-col w-full max-w-lg" id="admin-calendar-form">
    <v-app>
      <v-date-picker
        no-title
        locale="es-ES"
        :allowed-dates="allowedDates"
        first-day-of-week="1"
        color="secondary"
        v-model="selectedDate"
        :disabled="loading"
        @change="handleSelectDate"
        @update:picker-date="update"
      ></v-date-picker>
    </v-app>

    <div class="mt-10 mb-16" v-if="dataLoaded">
      <p v-if="noReservationsThisMonth" class="font-bold text-lg">{{$t('admin-calendar.no-reservations')}}</p>
      <div v-else-if="selectedDate">
        <h2 class="font-bold text-lg mb-2">
          {{$t('admin-calendar.reservation-for')}} {{ selectedDateFormatted }}:
        </h2>
        <table class="table-auto" v-if="selectedDateReservations">
          <thead>
            <tr>
              <th class="px-4 py-2">idx</th>
              <th class="px-4 py-2">code</th>
              <th class="px-4 py-2">sentarse</th>
              <th class="px-4 py-2">transfer</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :class="{'bg-gray-100': idx %2 ==1 }"
              v-for="(reservation, idx) in selectedDateReservations"
              :key="reservation.id"
            >
              <td class="border px-4 py-2">{{idx+1}}</td>
              <td class="border px-4 py-2">
                <a
                  class="hover:underline"
                  :href="`/admin/resources/reservations/${reservation.id}`"
                  >{{ reservation.code }}</a
                >
              </td>
              <td class="border px-4 py-2 text-center">{{reservation.extras.find(e => e.id == 1) ? reservation.extras.find(e => e.id == 1).title : '-' }}</td>
              <td class="border px-4 py-2 text-center">{{reservation.extras.find(e => e.id == 2) ? reservation.extras.find(e => e.id == 2).title : '-' }}</td>
            </tr>
          </tbody>
        </table>
        <ul v-if="selectedDateReservations"></ul>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      selectedDate: null,
      loading: true,
      dataLoaded: false,
      reservations: {},
      yearShown: null,
      monthShown: null,
    };
  },

  methods: {
    allowedDates: function (val) {
      const [year, month, day] = val.split("-");

      return (
        !this.noReservationsThisMonth && this.reservations[year][month][day]
      );
    },

    handleSelectDate(date) {
      this.selectedDate = date;
    },
    getExtra(extra_id){
      return this.reservation.extras.find(e => e.id == extra_id);
    },
    update(yearAndMonthShown) {
      const [year, month] = yearAndMonthShown.split("-");
      this.selectedDate = null;
      this.reservations = {};
      this.dataLoaded = false;

      if (!month || (year !== this.yearShown && month === this.monthShown)) {
        return;
      }

      this.yearShown = year;
      this.monthShown = month;
      this.getReservations();
    },

    getReservations() {
      this.loading = true;

      axios
        .get(`/reservations/${this.yearShown}/${this.monthShown}`)
        .then(({ data }) => {
          this.reservations = typeof data === "object" ? data : {};
          this.dataLoaded = true;
          this.selectFirstDayWithReservations();
        })
        .catch(() => alert("Ha ocurrido un error."))
        .finally(() => (this.loading = false));
    },

    selectFirstDayWithReservations() {
      if (!this.noReservationsThisMonth) {
        const day = Object.keys(
          this.reservations[this.yearShown][this.monthShown]
        )[0];
        this.selectedDate = `${this.yearShown}-${this.monthShown}-${day}`;
      }
    },
  },

  computed: {
    selectedDateFormatted() {
      if (!this.selectedDate) return "";

      const [year, month, day] = this.selectedDate.split("-");

      return `${day}/${month}/${year}`;
    },

    selectedDateReservations() {
      if (!this.selectedDate) return [];

      const [year, month, day] = this.selectedDate.split("-");

      return this.reservations[year][month][day];
    },

    noReservationsThisMonth() {
      if (!this.yearShown) return false;

      return !(
        this.reservations[this.yearShown] &&
        this.reservations[this.yearShown][this.monthShown]
      );
    },
  },
};
</script>

<style scoped>
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #00adbc !important;
}
</style>
